(ns ui.components.input.percentage
  (:require
   [common.number-format :as number-format]
   [common.util :as cu]
   [frontend.utils :as fu]
   [ui.components.input.number :as number-input]
   [ui.constants :as constants]
   [ui.util :as util]))

(defn format-value
  [{:keys [number-format]} value]
  (when (number? value)
    (number-input/format-value {:min-decimals     0
                                :max-decimals     2
                                :number-format    number-format
                                :percentage-mode? true}
                               (* value 100))))

(defn parse-value
  [str-value number-format]
  (let [str-value (cu/str-trim-lcase str-value)
        ends-with-%? (= (last str-value) "%")
        float-meta (util/parse-float-info
                    (if number-format
                      (number-format/decimal-separator number-format)
                      constants/decimal-separator)
                    (if ends-with-%?
                      (apply str (butlast str-value))
                      str-value)
                    nil)
        {:keys [float-value]} float-meta
        is-within-bounds? (and (number? float-value)
                               (< constants/MIN-SAFE-INTEGER float-value constants/MAX-SAFE-INTEGER))]
    (if-not is-within-bounds?
      nil
      (if ends-with-%?
        (float (/ float-value 100))
        float-value))))

(def eps 1e-10)

(defn safe-percent [x]
  (let [res (* x 100)]
    (if (< (js/Math.abs (- res (js/Math.round res))) eps)
      (js/Math.round res)
      res)))

(defn view
  [{:keys [_id class value on-blur on-change variant transparent?] :as props}]
  (let [r-value (if (or (float? value)
                        (int? value))
                  (safe-percent value)
                  nil)
        divide-by-100-w-cb (fn [value callback]
                             (let [per-value (if (or (float? value)
                                                     (int? value))
                                               (/ value 100)
                                               nil)]
                               (when (fn? callback)
                                 (callback per-value))))]
    [number-input/view
     (merge
      props
      {:value            r-value
       :class-name       (fu/cs "peer rounded px-3 placeholder-transparent focus:outline-none focus:ring-0 text-md"
                                (if transparent?
                                  "bg-transparent disabled:bg-transparent"
                                  "text-input-light-text disabled:text-disabled-regular-text
                                   bg-input-light disabled:bg-disabled-regular")
                                (if (not= variant :borderless)
                                  "py-2 border border-input-light-border-paler hover:border-input-light-border focus:border-input-light-border"
                                  "py-2 border-none focus:border-transparent ")
                                (when-not (cu/blank-value? r-value)
                                  "value")
                                class)
       :percentage-mode? true
       :min-decimals     2
       :max-decimals     2
       :on-change        (fn [updated-value]
                           (divide-by-100-w-cb updated-value on-change))
       :on-blur          (fn [updated-value]
                           (divide-by-100-w-cb updated-value on-blur))})]))
